import { reports } from 'api/reports';
import { auth } from 'api/auth';
import actions from 'actions';
import { store } from 'store';

const reportsApi = {
  token: null,

  req(method, path, data, success, fail, withAuth) {
    const xhr = new XMLHttpRequest();
    xhr.open(method, `${import.meta.env.VITE_REPORTS_URL}${path}`);
    xhr.setRequestHeader('Content-Type', 'application/json');
    if (withAuth && reportsApi.token) {
      xhr.setRequestHeader('Authorization', `Bearer ${reportsApi.token}`);
    }
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          let response;
          try { response = JSON.parse(xhr.responseText); } catch (err) {
            console.error(err);
          }
          if (success) success(response);
        } else {
          if (xhr.status === 401 && reportsApi.token) this.auth.localLogout(() => store.dispatch(actions.auth.logout()));
          let message;
          try { message = JSON.parse(xhr.responseText).message; } catch (err) { if (fail) fail({ status: xhr.status, message: 'There was a problem with this request' }); }
          if (fail) fail({ status: xhr.status, message });
        }
      }
    };
    xhr.send(data && JSON.stringify(data));
  },

  authenticatedRequest(method, path, data, success, fail) {
    reportsApi.req(method, path, data, success, fail, true);
  },
};
reportsApi.reports = reports(reportsApi);
reportsApi.auth = auth(reportsApi);

export default reportsApi;
